import { gql } from "@apollo/client";

export const GET_DELEGACIONES = gql`
query QGetDelegaciones ($idRegion: Int!) {
    delegaciones (idRegion: $idRegion)
        {
            success,
            error,
            valorEsperado {
                idRegion,
                region,
                idDelegacion,
                descripcion,
                activo,
                cod_Delegacion
            }
        }
}`;